import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { AuthContext } from '../authentication/AuthContext';
import { Card, CardActionArea, CardMedia, CardContent, IconButton } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { NavigatorData, Products } from './NavigatorData';
import { DeltaXMLColors, MyDeltaColors } from './styling/DeltaColors';
import PersonIcon from '@material-ui/icons/Person';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import GetAppIcon from '@material-ui/icons/GetApp';
// import WidgetsIcon from '@material-ui/icons/Widgets';

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      maxWidth: 936,
      height: 575,
      margin: 'auto',
      overflow: 'hidden'
    },
    contentWrapper: {
      margin: '20px 10px 5px 10px',
      cursor: 'default'
    },
    bannerCard: {
      width: 926,
      backgroundColor: DeltaXMLColors.CONCRETE,
      height: 230
    },
    comingSoonCard: {
      // to show this card, use display: 'flex'
      display: 'none',
      width: 200,
      height: 207,
      backgroundColor: DeltaXMLColors.CONCRETE
    },
    featureCard: {
      width: '100%',
      height: 207,
      backgroundColor: DeltaXMLColors.CONCRETE
    },
    media: {
      height: 230
    },
    announcementWrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '5px 10px 5px 10px',
      cursor: 'default'
    },
    bannerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '5px 10px 10px 10px',
      cursor: 'default'
    },
    linkStyle: {
      textDecoration: 'none',
      position: 'relative'
    },
    innerCard: {
      width: '100%',
      height: 143,
      margin: '2px',
      position: 'relative'
    },
    innerCardWrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0px'
    },
    innerCardContent: {
      height: 143
    },
    outerCardHeading: {
      marginLeft: '5px',
      fontWeight: 'bold',
      color: DeltaXMLColors.OXFORD_BLUE
    },
    iconImage: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      margin: 'auto',
      opacity: '0.1',
      color: DeltaXMLColors.GRAY,
      fontSize: 90
    },
    logoImage: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      margin: 'auto',
      opacity: '0.1',
    }
  });

export interface ContentProps extends WithStyles<typeof styles> { }

function Content(props: ContentProps) {
  const { classes } = props;
  const auth = React.useContext(AuthContext);
  return (
    auth.isAuthenticated() ?
      <Paper className={classes.paper}>
        <div className={classes.contentWrapper}>
          <Typography align="center" variant="h4" style={{ color: DeltaXMLColors.OXFORD_BLUE }}>
            Welcome to MyDelta
          </Typography>
          <Typography align="center" variant="h5" style={{ fontWeight: 'normal', color: DeltaXMLColors.OXFORD_BLUE }}>
            <p style={{ margin: '10px 0px' }}>
              <>Manage your DeltaXignia Account with MyDelta</>
            </p>
          </Typography>
        </div>
        <div className={classes.announcementWrapper}>
          <Card className={classes.featureCard} style={{ backgroundColor: MyDeltaColors.GHOST }}>
            <CardContent style={{ padding: '10px' }}>
              <Typography gutterBottom variant="h5" className={classes.outerCardHeading}>
                Features
              </Typography>
              <div className={classes.innerCardWrapper}>
                <Card className={classes.innerCard}>
                  <Link to={NavigatorData.profileBaseUrl} className={classes.linkStyle}>
                    <CardActionArea className={classes.linkStyle}>
                      <CardMedia>
                        <PersonIcon className={classes.iconImage} />
                      </CardMedia>
                      <CardContent className={classes.innerCardContent}>
                        <Typography variant="h6">
                          Your MyDelta Profile
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Review and edit your Profile Information
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Link>
                </Card>
                <Card className={classes.innerCard}>
                  <Link to={NavigatorData.licenseManagerBaseUrl} className={classes.linkStyle}>
                    <CardActionArea className={classes.linkStyle}>
                      <CardMedia>
                        <VpnKeyIcon className={classes.iconImage} />
                      </CardMedia>
                      <CardContent className={classes.innerCardContent}>
                        <Typography variant="h6">
                          License Manager
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          View and manage your Licenses
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Link>
                </Card>
                <Card className={classes.innerCard}>
                  <Link to={NavigatorData.downloadProductUrl} className={classes.linkStyle}>
                    <CardActionArea className={classes.linkStyle}>
                      <CardMedia>
                        <GetAppIcon className={classes.iconImage} />
                      </CardMedia>
                      <CardContent className={classes.innerCardContent}>
                        <Typography variant="h6">
                          Your Downloads
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Download all your DeltaXignia products
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Link>
                </Card>
                  {/* <Card className={classes.innerCard}>
                    <Link to={NavigatorData.saasProductsBaseUrl + '/' + Products.deltaJson} className={classes.linkStyle}>
                      <CardActionArea className={classes.linkStyle}>
                        <CardMedia>
                          <img src="/DeltaJSONIcon_Dark.png" alt='DeltaJSON' className={classes.logoImage} />
                        </CardMedia>
                        <CardContent className={classes.innerCardContent}>
                          <Typography variant="h6">
                            DeltaJSON Subscription
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Start or manage your Subscriptions
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Link>
                  </Card> */}
                  {/* <Card className={classes.innerCard}>
                    <Link to={NavigatorData.saasProductsBaseUrl} className={classes.linkStyle}>
                      <CardMedia>
                        <WidgetsIcon className={classes.iconImage} />
                      </CardMedia>
                      <CardContent className={classes.innerCardContent}>
                        <Typography variant="h6">
                          Content Compare SaaS
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p">
                          Start or manage your Content Compare Subscriptions
                        </Typography>
                      </CardContent>
                    </Link>
                  </Card> */}

              </div>
            </CardContent>
          </Card>
          <Card className={classes.comingSoonCard} style={{ marginLeft: '5px', backgroundColor: MyDeltaColors.GHOST }}>
            <CardContent style={{ padding: '10px' }}>
              <Typography gutterBottom variant="h5" className={classes.outerCardHeading}>
                Coming Soon
              </Typography>
              <div className={classes.innerCardWrapper}>
                <Card className={classes.innerCard}>
                  <CardMedia>
                    <img src="/Delta_Grey_medium.png" alt="DeltaXML" className={classes.logoImage} />
                  </CardMedia>
                  <CardContent className={classes.innerCardContent}>
                    <Typography variant="h6">
                      MyDelta Revamp
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      MyDelta Styling updates with website revamp
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            </CardContent>
          </Card>
        </div>
        <div className={classes.bannerWrapper}>
          <Card className={classes.bannerCard}>
            <Link to={NavigatorData.licenseManagerBaseUrl} className={classes.linkStyle}>
              <CardMedia
                className={classes.media}
                image="/MyDeltabanner.jpg"
                title="MyDeltabanner"
              />
            </Link>
          </Card>
        </div>
      </Paper >
      :
      <></>
  );
}

export default withStyles(styles)(Content);
